export const colors = {
  dark_sky_blue: '#97C0CE',
  neutral_blue: '#5790BD',
  anti_flash_white: '#EDEFFA',
  white: '#ffffff',
  black: 'rgba(0,0,0,0.7)',
  disabled_gray: '#ccc',
  configWhite: '#fefefe',
  lemon_curry: '#cd9323',
  new_car: '#1a53d8',
  big_dip_ruby: '#9a2151',
  deep_green: '#0d6416',
  smokey_topaz: '#8d2808',
  gold: '#FFD700',
  alloy_orange: '#B95E00',
  iguana_green: '#7AAA7B',
  deep_saffron: '#F89235',
  transparentWhite: 'rgba(255, 255, 255, 0.9)',
  columbia_blue: '#c0d9e1',
  gray: 'rgba(0, 0, 0, 0.54)',
  gray68: '#adadad',
  sasquatch: 'rgb(255, 64, 129)',
  container_grey: '#f9f9f9',
}

export const presetColors = [
  colors.dark_sky_blue,
  colors.gold,
  colors.alloy_orange,
  colors.iguana_green,
  colors.deep_saffron,
  colors.new_car,
  colors.lemon_curry,
  colors.big_dip_ruby,
  colors.deep_green,
  colors.smokey_topaz,
]

export const baseGridWidth = 300
export const baseInnerWidth = 768
export const TABLE_ROW_HEIGHT = 48
export const ADMIN_TABLE_MAX_WIDTH = 960
export const ADMIN_TABLE_COLUMN_NUMBER = 6
export const DRAWER_WIDTH = 248
export const MIN_WIDTH = 620
